import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { IrpfTableService } from './irpf-table.service';


@Component({
    selector: 'app-irpf-table',
    standalone: true,
    imports: [TableModule, TranslateModule, DecimalPipe, TooltipModule],
    templateUrl: './irpf-table.component.html',
    styleUrls: ['./irpf-table.component.scss']
})
export class IrpfTableComponent  {
    readonly irpfTableService = inject(IrpfTableService);
    private readonly translateService = inject(TranslateService);

    protected downloadExcel(): void {
        void this.irpfTableService.generateExcelBlob().then(blob => {
            const fileName = `${this.irpfTableService.queryId}_opendataweb_irpf_export_${this.translateService.currentLang}.xlsx`;
            saveAs(blob, fileName);
        });
    }

    protected isRentsRow(concept: string): boolean {
        return concept === 'IRPF.INCOME_AND_EXPENSES_FROM_BUSINESS_ACTIVITIES.RENTS';
    }
}
